// WHAT: React Context for managing layout state (sidebar open/closed)
// WHY:  Provides global state management for sidebar visibility across the application
// DOMAIN: Shared → Contexts
// DEPENDENCIES: React Context API
// RISKS:
//   - NOTE: Very minimal context - may need additional layout state later
//   - NOTE: No persistence - sidebar state resets on page reload

import { useState, type ReactNode } from "react";

import { LayoutContext } from "./LayoutContext.shared";

/**
 * WHAT:
 *   Provider component that manages layout state, specifically sidebar visibility.
 *
 * WHY:
 *   Provides a centralized way to control sidebar visibility across the application.
 *
 * BEHAVIOR:
 *   - Manages sidebar open/closed state
 *   - Provides setSidebarOpen function to control sidebar
 *   - Initializes with sidebar closed
 *
 * RISKS:
 *   - NOTE: Very minimal implementation - may need additional layout state (theme, etc.)
 *   - NOTE: No persistence - sidebar state resets on page reload
 *
 * @param root0 - Props object
 *
 * @param root0.children - Child components
 *
 * @returns LayoutProvider component
 *
 */
export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <LayoutContext.Provider value={{ setSidebarOpen, sidebarOpen }}>
      {children}
    </LayoutContext.Provider>
  );
};
